import { Component, type ErrorInfo, type ReactNode } from 'react'
import { funnelApi, initialSessionId } from '../lib/api'

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch(error: Error, info: ErrorInfo) {
    void funnelApi.event(initialSessionId, 'client_error', { errorCode: error.name || 'RENDER_ERROR', step: location.pathname.slice(0, 80) }).catch(() => {})
    if (import.meta.env.DEV) console.error(error, info)
  }
  render() {
    if (!this.state.failed) return this.props.children
    return <main className="min-h-dvh flex items-center justify-center px-5"><div className="card text-center"><div className="sticker-icon">♡</div><h1>Let’s try that moment again.</h1><p className="body-copy">Your saved progress is still here.</p><button className="primary-button" onClick={() => location.reload()}>Reload Bonded</button></div></main>
  }
}
